enum actionTypes {
  ADD_PROJECT = 'projects/ADD_PROJECT',
  UPDATE_PROJECT_LIST = 'projects/UPDATE_PROJECT_LIST',
  UPDATE_PROJECT = 'projects/UPDATE_PROJECT',
  UPDATE_LIST_ORDER = 'projects/UPDATE_LIST_ORDER',
}
export default actionTypes;
